import React from 'react';
import StandardModal from './Modal_Standard';

export const Cart = (props) => {

    const cartItems = (
        <ul className='cartItems'>
            {[{id: 'c1', name: 'sushi', amount: 2, price: 12.99}].map((item) => (
                <li>{item.name}</li>

            ))}

        </ul>
    )

    alert('Inside Cart');
    alert(cartItems);

    return (
        <StandardModal>
            {cartItems}
            <div>
                <span>Total Amount</span>
                <span>35.88</span>
            </div>
            <div>
                <button>Close</button>
                <button>Order</button>
            </div>
        </StandardModal>

    )
}
